export const FETCH_STUDENT_DECKS = 'FETCH_STUDENT_DECKS';
export const FETCH_STUDENT_DECK = 'FETCH_STUDENT_DECK';
